module.exports = __webpack_public_path__ + "media/svgs/elocal-caret-29c74e05.svg";